<template>
  <div>settings</div>
</template>
<script>
export default {
  name: "UserSettings",
};
</script>
